import { JobStatus } from 'model/JobStatus';
import dayjs from 'dayjs';

export interface ProcessLifecycleRespondentsResult {
  existingRespondents: number;
  newRespondents: number;
  orphanRespondents: number;
  orphanToRemove: number;
}

export type JobDto = {
  id: number;
  name: string;
  status: number;
  visited: boolean;

  reason?: string[];
  progress?: number;
  warnings?: string[];
  executionTime?: string; // ISO Date
  result?: unknown;
};

export type JobExtendedModel = {
  id: number;
  name: string;
  status: JobStatus;
  reason: any[] | { message: string } | null;
  progress: number;
  warnings: any[];
  executionTime: number;
  visited: boolean;
  result: ProcessLifecycleRespondentsResult | unknown;
};

export function mapJobExtendedModelToDto(model: JobExtendedModel): JobDto {
  return {
    id: model.id,
    name: model.name,
    status: model.status,
    visited: model.visited,
  };
}

export function mapJobDtoToExtendedModel(dto: JobDto): JobExtendedModel {
  const executionTime = dayjs(dto.executionTime);

  return {
    id: dto.id,
    name: dto.name,
    status: dto.status,
    reason: dto.reason,
    progress: dto.progress || 0,
    warnings: dto.warnings,
    executionTime: executionTime.isValid() ? executionTime.unix() : 0,
    visited: dto.visited,
    result: dto.result,
  };
}
